import { render, staticRenderFns } from "./ModalFamiliaExcluida.vue?vue&type=template&id=8af43344"
import script from "./ModalFamiliaExcluida.vue?vue&type=script&lang=js"
export * from "./ModalFamiliaExcluida.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports